$.fn.fn_part_ui_upload = function () {
    $(this).each(function () {
        var $el = $(this).find("[data-dropzone]");
        if ($el.length) {
            var options = $el.data("dropzone");
            $el.data('url-add') ? options['url'] = $el.data('url-add') : null;
            $el.data('clickable') ? options['clickable'] = $el.data('clickable') : null;

            options['removedfile'] = function (file) {
                $.ajax({
                    url: $el.data('url-remove') + '&fileIndex=' + file.index
                });
                var _ref;
                return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
            };

            options['success'] = function (file, index) {
                file.index = index;

                $.ajax({
                    data: {do: 'refresh'}
                });
            };

            var myDropzone = new Dropzone($el[0], options);

            $.each($el.data('files'), function () {
                var mockFile = this;
                mockFile.accepted = true;

                myDropzone.files.push(mockFile);
                myDropzone.emit("addedfile", mockFile);
                myDropzone.emit("thumbnail", mockFile, mockFile.path);
                myDropzone.emit("complete", mockFile);
            });
        }
    });
};

(function ($) {
    var $fn = $(".part_ui_upload");
    if ($fn.length) {
        $fn.fn_part_ui_upload();
    }
})(jQuery);